import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { ThankYouMPage } from './pages/ThankYouMPage';
import { VslPage } from './pages/VslPage';
import { VslIgPage } from './pages/VslIgPage';
import { OptinVslPage } from './pages/OptinVslPage';
import { RetargetingPage } from './pages/RetargetingPage';
import { ConfirmationPage } from './pages/ConfirmationPage';
import { ReplayPage } from './pages/ReplayPage';
import { LloydPage } from './pages/LloydPage';
import { HeyLloydPage } from './pages/HeyLloydPage';
import { HeyLloydCustomsPage } from './pages/HeyLloydCustomsPage';
import { HeyLloydBookACallPage } from './pages/HeyLloydBookACallPage';
import { WebinarReplyPage } from './pages/WebinarReplyPage';
import { WebinarReplyPageIndia } from './pages/WebinarReplyPageIndia';
import { BookingQualificationPage } from './pages/BookingQualificationPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { RegaloPage } from './pages/RegaloPage';
import { MeditationsPage } from './pages/MeditationsPage';
import { LlamadaConfirmationPage } from './pages/LlamadaConfirmationPage';
import { LlamadaAiPage } from './pages/LlamadaAiPage';
import { LlamadasSemanalesCursoPage } from './pages/LlamadasSemanalesCursoPage';
import { BookCallStrategyPage } from './pages/BookCallStrategyPage';
import { WebinarJuevesNewPage } from './pages/WebinarJuevesNewPage';
import { BreakoutVideoPage } from './pages/BreakoutVideoPage';
import { ReplayOfferPage } from './pages/ReplayOfferPage';
import { CaseStudy1050Page } from './pages/CaseStudy1050Page';
import { ComoIaPage } from './pages/ComoIaPage';
import { WelcomePage } from './pages/WelcomePage';
import { HistoriaPage } from './pages/HistoriaPage';
import { LeadMagnetHeyLloydDemoPage } from './pages/LeadMagnetHeyLloydDemoPage';
import { Faltan3DiasPage } from './pages/Faltan3DiasPage';
import { Faltan2DiasPage } from './pages/Faltan2DiasPage';
import { Faltan1DiaPage } from './pages/Faltan1DiaPage';
import { Faltan3HrsPage } from './pages/Faltan3HrsPage';
declare global {
  interface Window {
    fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Global Facebook Pixel — fires on every page
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Navigate to="/meta-jueves" replace data-id="element-3" />} data-id="element-2" />
        <Route path="/meta-martes" element={<LandingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/meta-jueves" element={<LandingPage data-id="element-7" />} data-id="element-6" />
        <Route path="/meta-jueves-rr" element={<LandingPage data-id="element-9" />} data-id="element-8" />
        <Route path="/reregister" element={<LandingPage data-id="element-11" />} data-id="element-10" />
        <Route path="/jon-test" element={<LandingPage data-id="element-13" />} data-id="element-12" />
        <Route path="/en-vivo" element={<LandingPage data-id="element-15" />} data-id="element-14" />
        <Route path="/bienvenidos" element={<LandingPage data-id="element-17" />} data-id="element-16" />
        <Route path="/bienvenidos-m" element={<LandingPage data-id="element-19" />} data-id="element-18" />
        <Route path="/news-brake" element={<LandingPage data-id="element-21" />} data-id="element-20" />
        <Route path="/organic-martes" element={<LandingPage data-id="element-23" />} data-id="element-22" />
        <Route path="/organic-jueves" element={<LandingPage data-id="element-25" />} data-id="element-24" />
        <Route path="/yt-jueves" element={<LandingPage data-id="element-27" />} data-id="element-26" />
        <Route path="/webinar-jueves-new" element={<WebinarJuevesNewPage data-id="element-29" />} data-id="element-28" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-31" />} data-id="element-30" />
        <Route path="/thank-you-m" element={<ThankYouMPage data-id="element-33" />} data-id="element-32" />
        <Route path="/vsl" element={<VslPage data-id="element-35" />} data-id="element-34" />
        <Route path="/vsl-ig" element={<VslIgPage data-id="element-37" />} data-id="element-36" />
        <Route path="/optin-vsl" element={<OptinVslPage data-id="element-39" />} data-id="element-38" />
        <Route path="/retargeting" element={<RetargetingPage data-id="element-41" />} data-id="element-40" />
        <Route path="/purchase-book-a-call" element={<ConfirmationPage data-id="element-43" />} data-id="element-42" />
        <Route path="/purchase-book-a-call-webinar" element={<ConfirmationPage data-id="element-45" />} data-id="element-44" />
        <Route path="/llamadas-semanales-curso" element={<LlamadasSemanalesCursoPage data-id="element-47" />} data-id="element-46" />
        <Route path="/book-call-strategy" element={<BookCallStrategyPage data-id="element-49" />} data-id="element-48" />
        <Route path="/replay" element={<ReplayPage data-id="element-51" />} data-id="element-50" />
        <Route path="/lloyd" element={<LloydPage data-id="element-53" />} data-id="element-52" />
        <Route path="/heylloyd" element={<HeyLloydPage data-id="element-55" />} data-id="element-54" />
        <Route path="/reply-webinar" element={<HeyLloydPage data-id="element-57" />} data-id="element-56" />
        <Route path="/webinar-reply" element={<WebinarReplyPage data-id="element-59" />} data-id="element-58" />
        <Route path="/in" element={<WebinarReplyPageIndia data-id="element-61" />} data-id="element-60" />
        <Route path="/book-call" element={<BookingQualificationPage data-id="element-63" />} data-id="element-62" />
        <Route path="/book-call-internal" element={<BookingQualificationPage data-id="element-65" />} data-id="element-64" />
        <Route path="/llamada-ai" element={<LlamadaConfirmationPage data-id="element-67" />} data-id="element-66" />
        <Route path="/heylloyd-customs" element={<HeyLloydCustomsPage data-id="element-69" />} data-id="element-68" />
        <Route path="/heylloyd-book-a-call" element={<HeyLloydBookACallPage data-id="element-71" />} data-id="element-70" />
        <Route path="/infocommerce-book-a-call" element={<HeyLloydBookACallPage data-id="element-73" />} data-id="element-72" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-75" />} data-id="element-74" />
        <Route path="/terms" element={<TermsPage data-id="element-77" />} data-id="element-76" />
        <Route path="/regalo" element={<RegaloPage data-id="element-79" />} data-id="element-78" />
        <Route path="/meditations" element={<MeditationsPage data-id="element-81" />} data-id="element-80" />
        <Route path="/llamada-confirmacion" element={<LlamadaConfirmationPage data-id="element-83" />} data-id="element-82" />
        <Route path="/vid1" element={<BreakoutVideoPage videoId="1173156247" title="¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?" videoNumber={1} data-id="element-85" />} data-id="element-84" />
        <Route path="/vid2" element={<BreakoutVideoPage videoId="1173156261" title="Ya he invertido en otros programas y no me funcionaron. ¿Qué hace a este diferente?" videoNumber={2} data-id="element-87" />} data-id="element-86" />
        <Route path="/vid3" element={<BreakoutVideoPage videoId="1173156277" title="No tengo tiempo para implementar otro sistema complejo." videoNumber={3} data-id="element-89" />} data-id="element-88" />
        <Route path="/vid4" element={<BreakoutVideoPage videoId="1173156217" title="Me preocupa el costo de la inversión. ¿Cuál es el ROI real?" videoNumber={4} data-id="element-91" />} data-id="element-90" />
        <Route path="/vid5" element={<BreakoutVideoPage videoId="1173156206" title="¿No puedo simplemente hacer lo mismo con ChatGPT y otras herramientas gratuitas?" videoNumber={5} data-id="element-93" />} data-id="element-92" />
        <Route path="/replay-offer" element={<ReplayOfferPage data-id="element-95" />} data-id="element-94" />
        <Route path="/1050-7-dias" element={<CaseStudy1050Page data-id="element-97" />} data-id="element-96" />
        <Route path="/como-ia" element={<ComoIaPage data-id="element-99" />} data-id="element-98" />
        <Route path="/welcome" element={<WelcomePage data-id="element-101" />} data-id="element-100" />
        <Route path="/historia" element={<HistoriaPage data-id="element-103" />} data-id="element-102" />
        <Route path="/lead-magnet-heylloyd-demo" element={<LeadMagnetHeyLloydDemoPage data-id="element-105" />} data-id="element-104" />
        <Route path="/faltan-3-dias" element={<Faltan3DiasPage data-id="element-107" />} data-id="element-106" />
        <Route path="/faltan-2-dias" element={<Faltan2DiasPage data-id="element-109" />} data-id="element-108" />
        <Route path="/faltan-1-dia" element={<Faltan1DiaPage data-id="element-111" />} data-id="element-110" />
        <Route path="/faltan-3-hrs" element={<Faltan3HrsPage data-id="element-113" />} data-id="element-112" />
        <Route path="*" element={<Navigate to="/meta-jueves" replace data-id="element-115" />} data-id="element-114" />
      </Routes>
    </BrowserRouter>;
}